import "../../scss/reset.css";
import "../../scss/mixins.scss";
import "../../scss/base.scss";

import React, { useState, useEffect, useCallback } from "react";
import { Link } from "gatsby";

import Sidebar from "../Sidebar/Sidebar";
import Logo from "../Logo/Logo";

import { library, config } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faCheck,
  faUser,
  faToolbox,
  faFolderOpen,
  faEnvelope,
  faCog,
  faPaperPlane,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as layoutStyles from "./Layout.module.scss";

config.autoAddCss = false;
library.add(fab, faUser, faCheck, faEnvelope, faToolbox, faFolderOpen, faCog, faPaperPlane, faTrash);

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleButton = useCallback(() => {
    if (window.innerWidth < 678) {
      setIsOpen(prev => !prev);
    }
  }, []);

  const closeMobileNav = useCallback(() => {
    if (window.innerWidth > 678 && isOpen) {
      setIsOpen(false);
    }
  }, [isOpen]);

  useEffect(() => {
    window.addEventListener("resize", closeMobileNav);
    return () => window.removeEventListener("resize", closeMobileNav);
  }, [closeMobileNav]);

  return (
    <div className={layoutStyles.page_wrap}>
      <nav>
        <div className={layoutStyles.socials}>
          <a
            href="https://github.com/malcolmu/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile"
          >
            <FontAwesomeIcon icon={["fab", "github"]} size="sm" />
          </a>
          <a
            href="https://www.linkedin.com/in/malcolmjjfernandes/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile"
          >
            <FontAwesomeIcon icon={["fab", "linkedin"]} size="sm" />
          </a>
        </div>
        <Link to="/" aria-label="Home">
          <Logo />
        </Link>
        <button
          className={`${layoutStyles.hamburger} ${isOpen ? layoutStyles.hamburgerActive : ""}`}
          onClick={toggleButton}
          aria-expanded={isOpen}
          aria-label={isOpen ? "Close navigation" : "Open navigation"}
        >
          <span className={layoutStyles.hamburgerBar} />
          <span className={layoutStyles.hamburgerBar} />
          <span className={layoutStyles.hamburgerBar} />
        </button>
      </nav>
      <Sidebar toggleSidebar={toggleButton} isOpen={isOpen} />
      <main id="main-panel">
        <div className={layoutStyles.container}>{children}</div>
      </main>
    </div>
  );
};

export default Layout;
